import { KnmAgreementStatusEnum } from 'KnmErknmPackage/ErknmViolationsModule/enums/KnmAgreementStatusEnum';

export const mapAgreementStatusToLabel: Record<KnmAgreementStatusEnum, string> = {
  [KnmAgreementStatusEnum.AGREEMENT_APPROVED]: 'Соглашение утверждено',
  [KnmAgreementStatusEnum.AGREEMENT_TERMINATED]: 'Соглашение расторгнуто',
  [KnmAgreementStatusEnum.AGREEMENT_COMPLETED]: 'Соглашение исполнено',
  [KnmAgreementStatusEnum.AGREEMENT_NOT_COMPLETED]: 'Соглашение не исполнено',
};
